import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuToggleOption} from '@Components/contextual-menu/components/contextual-menu-toggle-option';
import type {RGBA} from '@Utils/color.util';
import {BaseTintColorOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-tint-color-option';
import {BaseTintOpacityOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-tint-opacity-option';

interface BaseTintOptionProps {
  label?: string;
  tint: boolean;
  tintColor: RGBA;
  tintOpacity: number;

  onToggleTint(): void;

  onClickColorFill(): void;

  updateOpacity(value: number, undoable?: boolean): void;
}

export function BaseTintOption({label = window.i18next.t('pmwjs_tint'), ...props}: BaseTintOptionProps): ReactElement<any> {
  const onClickHandler = (): void => {
    props.onToggleTint();
  };

  const getTintColorOption = (): ReactElement<any> => {
    return (
      <BaseTintColorOption
        tintColor={props.tintColor}
        onClickColorFill={(): void => {
          props.onClickColorFill();
        }}
      />
    );
  };

  const getSubOptions = (): ReactElement<any> | null => {
    if (props.tint) {
      return (
        <>
          {getTintColorOption()}
          {getTintOpacityOption()}
        </>
      );
    }
    return null;
  };

  const getTintOpacityOption = (): ReactElement<any> => {
    return (
      <BaseTintOpacityOption
        tintOpacity={props.tintOpacity}
        updateOpacity={(value, undoable = true): void => {
          props.updateOpacity(value, undoable);
        }}
      />
    );
  };

  return (
    <ContextualMenuToggleOption id="item-tint-option" label={label} isChecked={props.tint} onClick={onClickHandler}>
      {getSubOptions()}
    </ContextualMenuToggleOption>
  );
}
